import { Component, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subscription } from 'rxjs';
import { delay, take } from 'rxjs/operators';
import { MeYouService } from 'src/app/core/services/me.you.service';
import { ResponseSnackbarComponent } from 'src/app/shared/components/response-snackbar/response-snackbar.component';
import { KaikasService, LoginInfo } from '../../core/services/kaikas.service';
import { LoaderService } from '../../core/services/loader.service';
import { FilterCatsService, ICatsFilter } from './../my-cats/filter-cats.service';
import { ModalTransferCatsComponent } from './../my-cats/modal-transfer-cats/modal-transfer-cats/modal-transfer-cats.component';


@Component({
  selector: 'app-my-meyou',
  templateUrl: './my-me-you.component.html',
  styleUrls: ['./my-me-you.component.scss']
})
export class MyMeYouComponent implements OnInit, OnChanges {

  constructor(
    public kaikas:KaikasService,
    public meYouService:MeYouService,
    private loader: LoaderService,
    private filterService: FilterCatsService,
    public dialog: MatDialog,
    private snackBar: MatSnackBar
    ) {

   }
  ngOnChanges(changes: SimpleChanges): void {
    // throw new Error('Method not implemented.');
  }

  rarityList: string[] = ['Common', 'Rare', 'Epic', 'Legendary'];


  filterForm = new FormGroup({
    rarity: new FormControl(''),
    mining: new FormControl(''),
  });

  public isLoading: boolean = true;
  public myItems:any[] = [];
  private loaderSearch: string = "Searching for your cats ...";
  private loaderNoCats: string = "You have no cats on this profile.";

  public loaderMessage: string = this.loaderSearch;

  private onLoginSubscription?:Subscription;
  private onItemsFetchedSubscription?:Subscription;
  private onFilterSubscription?:Subscription;
  private onCheckChanged?:Subscription;
  private lastFetchedAddress:string = "";

  public transferingInProgress: boolean;

  public selectedCats: number;

  ngOnInit(): void {

    this.loader.isLoading.pipe(delay(0)).subscribe((loading) =>{
      this.isLoading = loading
    });

    this.onItemsFetchedSubscription = this.meYouService.myItems.subscribe((items:string[])=>{
      console.log("fetched items", items)
      this.myItems = items;
      if (items.length == 0) {
        this.loaderMessage = this.loaderNoCats;
      }
    })

    this.onLoginSubscription = this.kaikas.loginInfoObserver.subscribe((loginInfo:LoginInfo)=>{
      if (loginInfo.address != this.lastFetchedAddress) {
        this.lastFetchedAddress = loginInfo.address;
        this.meYouService.fetchItems();
      }
    });

    this.onCheckChanged = this.filterService.checkChanged.subscribe((val:string)=>{
      this.selectedCats = 0;
      for(let i=0; i<this.myItems.length; i++) {
        if (this.myItems[i].checked) {
          this.selectedCats++;
        }
      }
    });

    this.filterForm.valueChanges.subscribe( x => {
      this.filterService.changeFilter(x.rarity, x.mining);
    })

    this.onFilterSubscription = this.filterService.currentFilter.subscribe((filter:ICatsFilter)=>{
      if (filter.checkboxes == false) {
        this.transferingInProgress = false;
      } else {
        if (filter.actionType == "TRANSFER")
          this.transferingInProgress = true;
      }
    });
    this.cancelCheckboxes();
  }

  private getSelectedCatIds() {
    let cats:number[] = [];
    for(let i=0; i<this.myItems.length; i++) {
      if (this.myItems[i].checked) {
        cats.push(this.myItems[i].catId);
      }
    }
    return cats;
  }

  completeTransfer() {

    const dialogRef = this.dialog.open(ModalTransferCatsComponent, {
      width: '600px',
      maxWidth: '100vw',
      autoFocus: false,
      data: this.getSelectedCatIds()
    });
    dialogRef.afterClosed().subscribe(result => {
        this.cancelCheckboxes();
    });
  }

  ngOnDestroy() {
    this.onLoginSubscription?.unsubscribe();
    this.onItemsFetchedSubscription?.unsubscribe();
    this.onFilterSubscription?.unsubscribe();
    this.onCheckChanged?.unsubscribe();
  }

  cancelCheckboxes() {
    this.filterService.hideCheckboxes();
  }
}
